var map = {
	"./about-us-photo": 208,
	"./about-us-photo.jpg": 208,
	"./access-and-innovation": 209,
	"./access-and-innovation.jpg": 209,
	"./advocacy-photo": 210,
	"./advocacy-photo.jpg": 210,
	"./alique-partner": 211,
	"./alique-partner.png": 211,
	"./arrow-down": 212,
	"./arrow-down-country": 213,
	"./arrow-down-country.svg": 213,
	"./arrow-down.svg": 212,
	"./article-photo": 214,
	"./article-photo.jpg": 214,
	"./australian-government": 215,
	"./australian-government.png": 215,
	"./author-f": 216,
	"./author-f.png": 216,
	"./back-arrow": 217,
	"./back-arrow.svg": 217,
	"./blue-photo": 218,
	"./blue-photo.jpg": 218,
	"./blue-rectangle": 219,
	"./blue-rectangle.png": 219,
	"./board-of-directors": 220,
	"./board-of-directors.jpg": 220,
	"./budget-advocacy": 221,
	"./budget-advocacy.jpeg": 221,
	"./calendar": 222,
	"./calendar.svg": 222,
	"./check-box": 223,
	"./check-box.svg": 223,
	"./chevron": 198,
	"./chevron-solid-down": 224,
	"./chevron-solid-down.svg": 224,
	"./chevron.svg": 198,
	"./children-home": 225,
	"./children-home.jpg": 225,
	"./circles": 226,
	"./circles.png": 226,
	"./curly-line-main": 227,
	"./curly-line-main.svg": 227,
	"./download": 199,
	"./download.svg": 199,
	"./ellipse-3": 228,
	"./ellipse-3.svg": 228,
	"./external-link": 229,
	"./external-link.svg": 229,
	"./fb": 230,
	"./fb-only-letter": 231,
	"./fb-only-letter.svg": 231,
	"./fb.svg": 230,
	"./footer-line": 232,
	"./footer-line.svg": 232,
	"./fresh-partner": 233,
	"./fresh-partner.png": 233,
	"./home-hero-image": 234,
	"./home-hero-image.jpg": 234,
	"./india-president": 235,
	"./india-president.svg": 235,
	"./innovation-photo": 236,
	"./innovation-photo.jpg": 236,
	"./labore-partner": 237,
	"./labore-partner.png": 237,
	"./large-human": 238,
	"./large-human.svg": 238,
	"./latest-header-photo": 239,
	"./latest-header-photo.jpg": 239,
	"./leaders-photo": 240,
	"./leaders-photo.jpg": 240,
	"./line-circle": 241,
	"./line-circle-teal": 242,
	"./line-circle-teal.svg": 242,
	"./line-circle.svg": 241,
	"./linked-in": 243,
	"./linked-in.svg": 243,
	"./linkedin": 244,
	"./linkedin.svg": 244,
	"./location": 245,
	"./location.svg": 245,
	"./logo": 246,
	"./logo-large": 247,
	"./logo-large.png": 247,
	"./logo-large@2x": 248,
	"./logo-large@2x.png": 248,
	"./logo.png": 246,
	"./logo@2x": 249,
	"./logo@2x.png": 249,
	"./magna-partner": 250,
	"./magna-partner.png": 250,
	"./map": 251,
	"./map.svg": 251,
	"./medicine": 252,
	"./medicine-card": 253,
	"./medicine-card.svg": 253,
	"./medicine.svg": 252,
	"./minus": 200,
	"./minus.svg": 200,
	"./money": 254,
	"./money.svg": 254,
	"./newsletter-svg": 255,
	"./newsletter-svg.svg": 255,
	"./next": 183,
	"./next.svg": 183,
	"./person": 256,
	"./person.svg": 256,
	"./photo-blog": 257,
	"./photo-blog.jpg": 257,
	"./photo-event": 258,
	"./photo-event.jpg": 258,
	"./photo-newsletter": 259,
	"./photo-newsletter.jpg": 259,
	"./plus": 201,
	"./plus.svg": 201,
	"./policy-circles": 260,
	"./policy-circles.png": 260,
	"./political-commitment": 261,
	"./political-commitment-photo": 262,
	"./political-commitment-photo-cover": 263,
	"./political-commitment-photo-cover.jpg": 263,
	"./political-commitment-photo.jpg": 262,
	"./political-commitment.jpg": 261,
	"./prev": 184,
	"./prev.svg": 184,
	"./print": 264,
	"./print.svg": 264,
	"./protection": 265,
	"./protection.svg": 265,
	"./related-photo": 266,
	"./related-photo-2": 267,
	"./related-photo-2.jpg": 267,
	"./related-photo.jpg": 266,
	"./resource-types/doc": 190,
	"./resource-types/doc.svg": 190,
	"./resource-types/external": 191,
	"./resource-types/external.svg": 191,
	"./resource-types/image": 192,
	"./resource-types/image.svg": 192,
	"./resource-types/other": 193,
	"./resource-types/other.svg": 193,
	"./resource-types/pdf": 194,
	"./resource-types/pdf.svg": 194,
	"./search": 268,
	"./search-white": 202,
	"./search-white.svg": 202,
	"./search.svg": 268,
	"./small-circle": 269,
	"./small-circle-teal": 270,
	"./small-circle-teal.svg": 270,
	"./small-circle.svg": 269,
	"./stop-box": 271,
	"./stop-box.svg": 271,
	"./stop-sign": 272,
	"./stop-sign.svg": 272,
	"./team-photo": 273,
	"./team-photo.jpg": 273,
	"./technical-expertise": 274,
	"./technical-expertise.jpg": 274,
	"./traffic-light": 275,
	"./traffic-light.svg": 275,
	"./twitter": 276,
	"./twitter-bird": 277,
	"./twitter-bird.svg": 277,
	"./twitter.svg": 276,
	"./video-screenshot": 278,
	"./video-screenshot.jpg": 278
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 381;